import axios from 'axios'
//import request from '@/axios/token'
import store from '@/vuex/store.js';
import * as types from './../vuex/types'
// const root = process.env.API_ROOT

// baseURL.baseHost
// axios配置
axios.defaults.timeout = 40000
  //axios.defaults.baseURL = 'http://172.30.112.101:8080/health/'
axios.defaults.headers.post['Content-Type'] = 'application/json'
  // POST传参序列化
axios.interceptors.request.use(

    config => {
      // config.headers={'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'}
      //if (config.method === 'post') {

      // config.data = qs.stringify(config.data);
      //  config.headers.post["Content-Type"]='application/json';
      //}
      // config.headers.common["token"] = store.state.token;
      let token = sessionStorage.getItem('token');
      //let token = "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJBWTA1ODA2NyIsInVzZXJJZCI6IkFZMDU4MDY3IiwiaWF0IjoxNjE2NzIyNTEyLCJleHAiOjE2MTY3Mjk3MTJ9.f4a9ilNkbVhExoxfG_UqbRUiSgNdRTJtB_fkUrK-me4"
      if (token) {
        config.headers.common["token"] = token;
      }
      return config
    },
    error => {
      return Promise.reject(error)
    }
  )
  // 返回状态判断

axios.interceptors.response.use(
  res => {
    return res
  },
  error => {
    console.log(error)
    if (error.response.status == "401") {
      let token = "";
      sessionStorage.setItem("token", token);
      store.commit(types.SET_TOKEN, token);

      var url = window.location.href; //获取当前页面的url
      if (url.indexOf("?") != -1) {
        var url1 = url;
        var str = url.indexOf("?");
        url = url.substring(0, str);
        var str2 = url1.indexOf("#");
        url1 = url1.substring(str2, url1.length);
        var url2 = url + url1;
        window.location.href = url2
      }
    }
    // return Promise.reject(error)
  }
)

// 封装get方法

export function get(url, params) {

  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(
        response => {
          resolve(response.data)
        },
        err => {
          reject(err)
        }
      )
      .catch(error => {
        reject(error)
      })
  })
}

// 封装post方法

export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, JSON.stringify(params))
      .then(
        response => {
          resolve(response.data)
        },
        err => {
          reject(err)
        }
      )
      .catch(error => {
        reject(error)
      })
  })
}

// 存在两种导出方式 export 和export default
// export default只能有一个
// export 可以有多个 导入时要加{} 例:import {b} from '@/api.js'
export default ({
  // 获取用户信息

  getToken(params) {
    return post('/wxapp/ehome/token', params)
  },
  getInfo(params) {
    return post('wechatPlatform/weixin/jsapi', params)
  },
  getResultByGroup(params) {
    return get('/jeecg-boot/jx/Calculate/getResultByGroup', params)
  },
  getResultBydept(params) {
    return get('/jeecg-boot/jx/DirectorCalController/getResultBydept', params)
  },
  getResult(params) {
    return get('/jeecg-boot/jx/PresidentCalController/getResult', params)
  },
  //医保均次
  getDailyCountData(params) {
    return get('/jeecg-boot/jx/ayjxBasicHisdailymedical/getDailyCountData', params)
  },
  //获取医生核算子分类明细
  getExaminationDetails(params) {
    return get('/jeecg-boot/jx/Calculate/getExaminationDetails', params)
  },
  //获取医生检查相关明细
  getCheckRelated(params) {
    return get('/jeecg-boot/jx/Calculate/getCheckRelated', params)
  },
  //获取医生收住院明细
  getNumberOfInpatientDetails(params) {
    return get('/jeecg-boot/jx/Calculate/getNumberOfInpatientDetails', params)
  },
  //获取医生单项奖励明细
  getSingleFee(params) {
    return get('/jeecg-boot/jx/Calculate/getSingleFee', params)
  },
  //获取医生单项医保明细
  getDoctorData(params) {
    return get('/jeecg-boot/jx/ayjxBasicHisdailymedical/getDoctorData', params)
  },

  //全院别页面数据

  getDirectorInfo(bookTime) {
    return get('/hospital-admin/api/ehome/book/director?bookTime=' + bookTime)
  },
  //科室别页面数据
  getDepartmentInfo(bookTime, detectionDepId, precise) {
    return get('/hospital-admin/api/ehome/book/department?bookTime=' + bookTime + '&detectionDepId=' + detectionDepId + '&precise=' + precise)
  },
  //根据医技科室id获取全部预约项目
  getAllBookItem(detectionDepId) {
    return get('/hospital-admin/api/ehome/book/bookItemList?detectionDepId=' + detectionDepId)
  },
  //科室详情页数据
  getPatientDetailList(detectionDepId, bookTime, bookItemId, precise) {
    return get('/hospital-admin/api/ehome/book/patientDetailList?detectionDepId=' + detectionDepId + '&bookTime=' + bookTime + '&bookItemId=' + bookItemId + '&precise=' + precise)
  },
  //患者搜索
  getPatientListSearch(bookTime, detectionDepId, precise, name) {
    return get('/hospital-admin/api/ehome/book/patients/list?bookTime=' + bookTime + '&strDetectionDepId=' + detectionDepId + '&strPrecise=' + precise + '&name=' + name)
  },
  //根据医技科室id获取医技科室信息
  getDetectionDep(detectionDepId) {
    return get('/hospital-admin/api/ehome/book/detectiondeps?detectionDepId=' + detectionDepId)
  },
  //医药物流
  getmanagerreport(params) {
    return get('/wxapp/ehome/dpitemsreport/getmanagerreport', params)
  },
  getdistributorreport(params) {
    return get('/dpitems/ehome/dpitemsreport/getdistributorreport', params)
  },
  getdeliverydetailbydate(params) {

    return get('/dpitems/ehome/dpitemsreport/getdeliverydetailbydate', params)
  },
  //spd
  //获取所有退货单列表

  getOrderReturnItems(params) {
    return get('/spd/api/ehome/return/getReturnOrderList', params)
  },

  //根据退货单id获取该退货单的详细信息

  getOrderReturnDetailByReturnNo(params) {
    return get('/spd/api/ehome/return/getReturnDetailForWaitCollect', params);
  },

  //获取药品详细信息

  getDrugDetail(params) {
    return get('/spd/api/ehome/return/getDrugDetailInfo', params);
  },

  //获取该退货单信息

  getOrderReturnByReturnNo(params) {
    return get('/spd/api/ehome/return/getOrderReturn', params);
  },

  getStepByReturnNo(params) {
    return get('/spd/api/ehome/return/getOrderReturnStatusStep', params);
  },

  //用户确认事件

  userSure(params) {
    return get('/spd/api/ehome/return/sureReturnReceive', params);
  },

  //获取该退货单信息

  getOrderLostByLostNo(params) {
    return get('/spd/api/ehome/lost/getReturnDetailForWaitCollect', params);
  },

  deleteImg(params) {
    return get('/spd/file/deleteImg', params);
  },

  //获取全院部门的电话随访结果

  getFeedbackCallInfo(date) {
    return get('/hospital-admin/api/ehome/call/allDepartments?date=' + date);
  },
  //根据部门id获取医技科室信息
  getDeptFeedbackCallInfo(date, depId) {
    return get('/hospital-admin/api/ehome/call/department?date=' + date + '&depId=' + depId);
  },

  //hr

  getJobMatch() {

    return get('/wxapp/ehome/job/match');
  },

  //spd

  turnover(params) {
    return get('/spd/api/ehome/report/hospital/turnover', params);
  },

  sales(params) {
    return get('/spd/api/ehome/report/hospital/sales', params);
  },
  rate(params) {
    return get('/spd/api/ehome/report/timely/rate', params);
  },
  ratePlus(params) {
    return get('/spd/api/ehome/report/recent/rate', params);
  },
  ratePlusSales(params) {
    return get('/spd/api/ehome/report/logistics/sales/month', params);
  },
  merge(params) {
    return get('/spd/api/ehome/report/logistics/sales/merge', params);
  },
  //人力资源
  getMatch(params) {
    return get('/wxapp/ehome/hrReport/match', params);
  },
  getListDataItems(params) {
    return get('/wxapp/weixin/listDataItems');
  },
  getHrReportDetail(params) {
    return get('/wxapp/ehome/hrReport/getHrReportDetail', params);
  },
  getSalartAndFormation(params) {
    return get('/wxapp/ehome/hrReport/getSalartAndFormation', params);
  },

  //获取跳转链接
  listDataItems(params) {
    return get('/wxapp/dataitem/listDataItems', params);
  },
})
//物流绩效
export const wlapi = {
  getResultBydept(params) {
    return get('/logistics/manager/report/getResultBydept', params);
  },
  getGroupDetail(params) {
    return get('/logistics/manager/report/getGroupDetail', params);
  },
  getDetail(params) {
    return get('/logistics/manager/report/getDetail', params);
  },
  getUserDetail(params) {
    return get('/logistics/manager/report/getUserDetail', params);
  },

}

export const spdLogistics = {
  //获取最近七天及时配送率和缺货率

  getTimeDeliveryRate() {

    return get('/spd/api/ehome/logistics/timeDeliveryRate');
  },

  //最近六月的销售总额,销售毛利

  getProfit() {

    return get('/spd/api/ehome/logistics/profit');
  },

  //内部医院价格策略销售分析

  getPriceStrategy(date) {

    return get('/spd/api/ehome/logistics/group/priceStrategy?date=' + date);
  }
}

export const ylrc = {
  //日统计
  getDaily(date) {
    return get('/wxapp/ehome/yuanLinProjectCostReport/getDaily?date=' + date);
  },
  //日趋势图
  getDailyTrend(date) {
    return get('/wxapp/ehome/yuanLinProjectCostReport/getDailyTrend?date=' + date);
  },
  //月统计
  getMonth(month) {
    return get('/wxapp/ehome/yuanLinProjectCostReport/getMonth?month=' + month);
  },
  //月趋势图
  getMonthTrend(month) {
    return get('/wxapp/ehome/yuanLinProjectCostReport/getMonthTrend?month=' + month);
  },
}


// WEBPACK FOOTER //
// ./src/axios/api.js